export const phoneCountries = [
  {
    code: 'AR',
    name: 'Argentina',
    dial: '+54',
    flag: 'https://hatscripts.github.io/circle-flags/flags/ar.svg',
  },
  {
    code: 'BO',
    name: 'Bolivia',
    dial: '+591',
    flag: 'https://hatscripts.github.io/circle-flags/flags/bo.svg',
  },
  {
    code: 'BR',
    name: 'Brasil',
    dial: '+55',
    flag: 'https://hatscripts.github.io/circle-flags/flags/br.svg',
  },
  {
    code: 'CL',
    name: 'Chile',
    dial: '+56',
    flag: 'https://hatscripts.github.io/circle-flags/flags/cl.svg',
  },
  {
    code: 'CO',
    name: 'Colombia',
    dial: '+57',
    flag: 'https://hatscripts.github.io/circle-flags/flags/co.svg',
  },
  {
    code: 'EC',
    name: 'Ecuador',
    dial: '+593',
    flag: 'https://hatscripts.github.io/circle-flags/flags/ec.svg',
  },
  {
    code: 'PY',
    name: 'Paraguay',
    dial: '+595',
    flag: 'https://hatscripts.github.io/circle-flags/flags/py.svg',
  },
  {
    code: 'PE',
    name: 'Perú',
    dial: '+51',
    flag: 'https://hatscripts.github.io/circle-flags/flags/pe.svg',
  },
  {
    code: 'UY',
    name: 'Uruguay',
    dial: '+598',
    flag: 'https://hatscripts.github.io/circle-flags/flags/uy.svg',
  },
  {
    code: 'VE',
    name: 'Venezuela',
    dial: '+58',
    flag: 'https://hatscripts.github.io/circle-flags/flags/ve.svg',
  },
  {
    code: 'MX',
    name: 'México',
    dial: '+52',
    flag: 'https://hatscripts.github.io/circle-flags/flags/mx.svg',
  },
  {
    code: 'US',
    name: 'Estados Unidos',
    dial: '+1',
    flag: 'https://hatscripts.github.io/circle-flags/flags/us.svg',
  },
  {
    code: 'ES',
    name: 'España',
    dial: '+34',
    flag: 'https://hatscripts.github.io/circle-flags/flags/es.svg',
  },
  {
    code: 'FR',
    name: 'Francia',
    dial: '+33',
    flag: 'https://hatscripts.github.io/circle-flags/flags/fr.svg',
  },
  {
    code: 'PT',
    name: 'Portugal',
    dial: '+351',
    flag: 'https://hatscripts.github.io/circle-flags/flags/pt.svg',
  },
  {
    code: 'GB',
    name: 'Reino Unido',
    dial: '+44',
    flag: 'https://hatscripts.github.io/circle-flags/flags/gb.svg',
  },
];
